import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function acknowledgedSignoffResponse(
   signoffRequestId: number,
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest(
      'patch',
      `/courses/stage-sign-offs/responses/${signoffRequestId}/acknowledge`,
      {
         ...common,
      }
   );
}
